import { CONFIGURE_OBJECT_CHOOSER } from './flowInformation.types'
import { DisplayObjectChooserType } from '../../../@types/object-chooser-types'
import { ConvertedRealEstate } from '../../../@types/real-estate-api-types'

export const configureObjectChooser = (
  displayObjectChooser: DisplayObjectChooserType,
  objects?: ConvertedRealEstate[],
  insertionFlowDataLoaded?: boolean,
  objectSelected?: boolean
) => ({
  type: CONFIGURE_OBJECT_CHOOSER,
  payload: { displayObjectChooser, objects, insertionFlowDataLoaded, objectSelected },
})
